import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sectionTitle: {
    id: 'CEkSWZ',
    defaultMessage: 'Account Information',
    description: 'Section title on the Edit Account Information sub-view',
  },
});
